function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.707 3.293l4.243 4.243c.39.39.39 1.023 0 1.414-.39.39-1.024.39-1.414 0L21 6.414v11.829l-.002.049c5.054.5 9.002 4.765 9.002 9.95 0 5.523-4.477 10-10 10s-10-4.477-10-10c0-5.186 3.948-9.45 9.003-9.95-.003-.016-.003-.033-.003-.05V6.415L16.464 8.95c-.39.39-1.023.39-1.414 0-.39-.39-.39-1.024 0-1.414l4.243-4.243c.39-.39 1.024-.39 1.414 0zM20 20.243c-4.418 0-8 3.581-8 8 0 4.418 3.582 8 8 8s8-3.582 8-8c0-4.419-3.582-8-8-8z",
  transform: "rotate(45 20 20.621)"
})));

function SvgMaleWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleWhite);
export default __webpack_public_path__ + "static/media/male-white.b4de0b66.svg";
export { ForwardRef as ReactComponent };